export const COMPARE_STORAGE_KEY = "carbatec_compare";
export const MAX_COMPARE_ITEMS = 3;

export type StoredCompareItem = {
  url: string;
  imageSrc?: string;
};

export const decodeHtmlEntities = (value: string): string => {
  const el = document.createElement("div");
  el.innerHTML = value;
  return el.textContent ?? value;
};

export const readStoredItems = (): StoredCompareItem[] => {
  try {
    const raw = localStorage.getItem(COMPARE_STORAGE_KEY);
    const list: unknown = raw ? JSON.parse(raw) : [];
    if (!Array.isArray(list)) return [];

    const items: StoredCompareItem[] = [];

    for (const entry of list) {
      if (typeof entry !== "object" || entry === null) continue;

      const urlValue: unknown = Reflect.get(entry, "url");
      const url = String(urlValue ?? "").trim();
      if (!url) continue;

      const imageSrcValue: unknown = Reflect.get(entry, "imageSrc");
      const imageSrc =
        typeof imageSrcValue === "string" ? imageSrcValue : undefined;

      items.push({ url, imageSrc });
    }

    return items;
  } catch {
    return [];
  }
};

export const getCompareHandles = (): string[] =>
  readStoredItems()
    .map((item) => /\/products\/([^/?]+)/.exec(item.url)?.[1] || "")
    .filter(Boolean)
    .slice(0, MAX_COMPARE_ITEMS);
